import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DocumentService } from '@app/shared/services/vault/document.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { CommonService } from '@app/shared/services';
import { InaccessibleWallDialogComponent } from '@app/shared/component/inaccessible-wall-dialog/inaccessible-wall-dialog.component';
import { AddDocumentComponent } from '../add-document.component';
import moment from 'moment';
import * as fileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { MyInboxUploadFileComponent } from '@app/shared/component/my-inbox-upload-file/my-inbox-upload-file.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { takeWhile } from 'rxjs/operators';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'non-document-attachment',
  templateUrl: './non-document-attachment.component.html',
  styleUrl: './non-document-attachment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NonDocumentAttachmentComponent implements OnInit, OnDestroy {
  @Input() has_document: boolean;
  @Input() suggested_documents: any[];
  @Input() currentFormId;
  @Input() currentuserId;
  @Input() vault_id;
  @Input() shareTypeData;
  @Input() isRemoveEditSaveSharing = false;
  isComponentActive = signal(true);
  @Output() suggestedDocumentEmitter = new EventEmitter<any>();
  @Output() attachDocumentEmitter = new EventEmitter<any>();
  @Output() summaryUpdateEmitter = new EventEmitter<any>();
  @Output() documentUpdateEvent = new EventEmitter<any>();
  @Output() nonDocumentAttachmentSelectionChange = new EventEmitter<{
    file: any;
    index: number;
    isChecked: boolean;
  }>();
  selectAll = false;
  isActiveDrag = false;
  isHovered = false;
  textBoxPlaceHolder = 'Search Kinnect';
  selectedFiles: any[] = [];
  hoveredFile: any = null;

  connectionUserFormControl = new UntypedFormControl();
  isInputFocused = false;
  files = [];
  isListViewOpen: boolean;
  searchText = '';
  nonDocumentAttachmentList: any[] = [];
  linkedDocuments: any[] = [];
  linkedDataDocuments: any[] = [];
  suggestions: any[] = [];
  subscription = new Subscription();
  loader = false;
  onInputFocus() {
    this.isInputFocused = true;
    if (!this.connectionUserFormControl.value) {
      this.isListViewOpen = false;
    }
  }

  onInputBlur() {
    this.isInputFocused = false;
  }

  reprocessAll() {
    this.linkedDocuments.forEach((element) => {
      if (!element.is_suggestion) {
        this.reprocessFile(element);
      }
    });
  }
  clearInput() {
    this.connectionUserFormControl.setValue('');
    this.isListViewOpen = false;
  }

  searchExisting() {}
  advanceSearch(option) {}
  async onMemberSearch(searchValue: string) {
    this.isInputFocused = true;
    this.loader = true;
    this.searchText = searchValue;
    this.cd.detectChanges();
  }
  constructor(
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private mxTaskbarService: MxTaskbarService,
    private commonService: CommonService,
    private http: HttpClient
  ) {}
  ngOnInit(): void {
    this.getNonDocumentAttachment();
    this.getLinkedDocuments();
    this.getSuggestions();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  uploadDocumentSelectionEmitter(event) {
    if (event.type === 'onFileSelected') {
      this.onFileSelected(event.event, event.data);
    } else if (event.type === 'openFileUpload') {
      this.openFileUpload();
    }
  }
  getSuggestions() {
    this.subscription.add(
      this.documentService.getNonDocumentSuggestions(this.currentFormId).subscribe((res) => {
        this.suggestions = res.map((item) => ({
          ...item,
          is_suggestion: true,
          display_file_name: item.link?.split('?')[0].split('/').pop(),
        }));
        this.mergeLinkedDocuments();
      })
    );
  }
  suggestedDocument() {
    this.suggestedDocumentEmitter.emit();
  }
  getNonDocumentAttachment() {
    this.subscription.add(
      this.documentService
        .getFormsLinkingSearch({
          user_id: this.currentuserId,
          vault_user_form_id: this.currentFormId,
          type: 'Documents',
        })
        .subscribe((res) => {
          this.nonDocumentAttachmentList = res.map((item) => ({
            ...item,
            link: item.upload_path,
            selected: false,
          }));
          this.cd.detectChanges();
        })
    );
  }
  getLinkedDocuments() {
    const body = {
      user_id: this.currentuserId,
      vault_user_form_id: this.currentFormId,
      type: 'Documents',
    };
    this.subscription.add(
      this.documentService.getFormsLinked(body).subscribe((res) => {
        this.linkedDataDocuments = res.data.map((item) => ({
          ...item,
          is_suggestion: false,
          link: item.upload_path,
        }));
        this.mergeLinkedDocuments();
        this.cd.detectChanges();
      })
    );
  }
  mergeLinkedDocuments() {
    this.linkedDocuments = [...this.linkedDataDocuments, ...this.suggestions];
    if (this.linkedDocuments.length === 0) {
      this.selectAll = false;
    }
    this.documentUpdateEvent.emit(this.linkedDocuments);
    this.cd.detectChanges();
  }
  nmaterialIconName(element) {
    if (element.display_file_name == undefined) {
      return 'doc';
    }
    let type = element.display_file_name.replace(/^.*\./, '') != element.display_file_name ? element.display_file_name.replace(/^.*\./, '') : '';
    if (type == '') {
      return 'doc';
    } else {
      return type.toLowerCase();
    }
  }
  downloadAll() {
    this.linkedDocuments.forEach((file) => {
      if (!file.is_suggestion) {
        this.downloadFile(file);
      }
    });
    this.clearEventHandler();
  }
  clearEventHandler() {
    this.linkedDocuments = this.linkedDocuments.map((item) => ({
      ...item,
      selected: false,
    }));
    this.selectedFiles = [];
    this.selectAll = false;
    this.cd.detectChanges();
  }
  onActionEmitter(event) {
    if (event.action === 'clear') {
      this.clearEventHandler();
    } else if (event.action === 'download') {
      this.selectedFiles.forEach((file) => {
        this.downloadFile(file);
      });
      this.clearEventHandler();
    }
  }
  onValueChange(event, file, index: number) {
    if (this.selectAll && !event.checked) {
      this.selectAll = false;
    }
    if (event.checked) {
      if (!this.selectedFiles.includes(file)) {
        this.selectedFiles.push(file);
      }
    } else {
      const fileIndex = this.selectedFiles.indexOf(file);
      if (fileIndex > -1) {
        this.selectedFiles.splice(fileIndex, 1);
      }
    }

    this.nonDocumentAttachmentSelectionChange.emit({
      file: file,
      index: index,
      isChecked: event.checked,
    });

    if (this.linkedDocuments.length > 0 && this.selectedFiles.length === this.linkedDocuments.length) {
      this.selectAll = true;
    }
    this.cd.detectChanges();
  }
  viewFile(file) {
    this.clearEventHandler();
    if (file.share_status === 'future') {
      const dialogRef = this.dialog.open(InaccessibleWallDialogComponent, {
        data: {
          form_name: file.form_name,
          shareDate: moment(file.sharedDate).format('MMM DD, YYYY'),
          type: file.type,
        },
        height: '520px',
        panelClass: 'full-window-dialog-2',
      });
    } else {
      let data_object = file;
      if (file.is_suggestion) {
        data_object.id = file.vufid;
      }
      const dialogOpen = this.dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: { file: data_object, mode: 'edit', isintelligent: false, isfileListLoad: true },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
      this.subscription.add(dialogOpen.afterClosed().subscribe(() => {}));
    }
  }
  openFileUpload(upload_file = null, dragged_data = null) {
    const dialogRef: MatDialogRef<MyInboxUploadFileComponent> = this.mxTaskbarService.openMxDialog(MyInboxUploadFileComponent, {
      disableClose: true,
      width: '690px',
      data: {
        origin: 'upload',
        setVaultId: true,
        upload_file: upload_file,
        dragged_data: dragged_data,
        vault_id: this.vault_id,
        currentFormId: this.currentFormId,
        userId: this.currentuserId,
      },
      panelClass: 'add_automation_email_modal',
      autoFocus: false,
    });
    this.subscription.add(dialogRef.componentInstance.mxDialogMinimized.pipe(takeWhile(() => this.isComponentActive())).subscribe(() => {}));
    this.subscription.add(
      dialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.isComponentActive()))
        .subscribe((val) => {
          this.getLinkedDocuments();
          this.summaryUpdateEmitter.emit();
        })
    );
  }
  onFileSelected(event, file) {
    this.subscription.add(
      this.documentService
        .createUserFormAssociation({
          user_id: this.currentuserId,
          associate_vault_user_form_id: file.id,
          created_by_user_id: this.currentuserId,
          vault_user_form_id: this.currentFormId,
          association_type: 'Documents',
        })
        .subscribe((res) => {
          this.summaryUpdateEmitter.emit();
          this.ngOnInit();
        })
    );
  }
  async uploadFile(event) {
    this.openFileUpload(event);
    this.cd.markForCheck();
  }
  myFunction(event) {
    this.isActiveDrag = false;
    this.cd.detectChanges();
  }
  onDragStart(event) {
    this.isActiveDrag = true;
    this.cd.detectChanges();
  }
  onDrag(event) {
    this.isActiveDrag = true;
    this.cd.detectChanges();
  }
  onDragEnd(event) {
    this.isActiveDrag = false;
    this.cd.detectChanges();
  }
  async dragged(event: DragEvent) {
    this.isActiveDrag = false;

    this.openFileUpload(null, event);
    this.cd.markForCheck();
  }
  attachDocument(template) {
    let payload = {
      user_id: this.currentuserId,
      vault_user_form_id: [template.suggested_vault_user_form_id],
      created_by_user_id: this.currentuserId,
      association_type: 'Documents',
      associate_vault_user_form_id: template.vault_user_form_id,
    };
    this.subscription.add(
      this.documentService.createUserFormAssociationMultiple(payload).subscribe(
        (res) => {
          this.subscription.add(
            this.documentService.updateDeactvateSuggestion(template.id).subscribe((res) => {
              this.ngOnInit();
              this.summaryUpdateEmitter.emit();
            })
          );
        },
        (error) => {}
      )
    );
  }
  reprocessFile(file) {
    this.subscription.add(
      this.documentService
        .createReProcessAiUploads({
          user_id: this.currentuserId,
          upload_id: file.vault_user_form_uploads_id,
          created_by_user_id: this.currentuserId,
          vault_user_form_id: this.currentFormId,
        })
        .subscribe((res) => {
          this.summaryUpdateEmitter.emit();
          this.ngOnInit();
        })
    );
  }
  downloadFile(file) {
    this.subscription.add(
      this.http.get(file.link, { responseType: 'blob' }).subscribe({
        next: (blob) => {
          fileSaver.saveAs(blob, file.display_file_name);
          this.clearEventHandler();
        },
        error: (err) => {
          console.error('Download failed', err);
        },
      })
    );
  }
  deleteForm(file) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: `Delete ${file.form_name}`,
        materialIcon: 'delete',
        text: `Are you sure you want to unlink ${file.form_name}?`,
        proceedTitle: 'Remove',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          if (file.is_suggestion) {
            this.subscription.add(
              this.documentService.updateDeactvateSuggestion(file.id).subscribe((result) => {
                this.clearEventHandler();
                this.ngOnInit();
                this.summaryUpdateEmitter.emit();
              })
            );
          } else {
            this.subscription.add(
              this.documentService
                .deleteUserFormAssociation(this.currentuserId, file.linked_form_id ? file.linked_form_id : file.formid, this.currentFormId)
                .subscribe((result) => {
                  this.summaryUpdateEmitter.emit();
                  this.clearEventHandler();
                  this.ngOnInit();
                })
            );
          }
        }
      })
    );
  }

  deleteNonDocumentAttachments(selectedFiles: any[]) {
    const filesToDelete = [...selectedFiles];
    let deleteCount = 0;
    const totalFiles = filesToDelete.length;
    filesToDelete.forEach((file) => {
      if (file.is_suggestion) {
        this.subscription.add(
          this.documentService.updateDeactvateSuggestion(file.id).subscribe((result) => {
            deleteCount++;
            if (deleteCount === totalFiles) {
              this.clearEventHandler();
              this.ngOnInit();
              this.summaryUpdateEmitter.emit();
            }
          })
        );
      } else {
        this.subscription.add(
          this.documentService
            .deleteUserFormAssociation(this.currentuserId, file.linked_form_id ? file.linked_form_id : file.formid, this.currentFormId)
            .subscribe((result) => {
              deleteCount++;
              if (deleteCount === totalFiles) {
                this.clearEventHandler();
                this.ngOnInit();
                this.summaryUpdateEmitter.emit();
              }
            })
        );
      }
    });
  }

  onSelectAllChange(checked: boolean) {
    if (checked) {
      this.selectedFiles = [...this.linkedDocuments];
    } else {
      this.selectedFiles = [];
    }

    this.linkedDocuments.forEach((file, index) => {
      file.selected = checked;
      this.nonDocumentAttachmentSelectionChange.emit({
        file: file,
        index: index,
        isChecked: checked,
      });
    });
    this.selectAll = checked;
    this.cd.detectChanges();
  }

  clearSelections() {
    this.clearEventHandler();
  }
}
